(() => {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const protectedMediaSelector = 'img, picture, svg, canvas, video, model-viewer';
  const protectedAssetSelector = `${protectedMediaSelector}, [style*="background-image"], [class*="image"], [class*="media"]`;

  const isProtectedAsset = (target) => target instanceof Element && target.closest(protectedAssetSelector);

  const disableMediaDragging = (root = document) => {
    root.querySelectorAll(protectedMediaSelector).forEach((element) => {
      element.setAttribute('draggable', 'false');
      element.setAttribute('oncontextmenu', 'return false;');
    });
  };

  disableMediaDragging();

  const allowsNativeContextMenu = (target) =>
    target instanceof Element && target.closest('input, textarea, select, [contenteditable="true"]');

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (allowsNativeContextMenu(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (!isProtectedAsset(event.target)) return;
      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'selectstart',
    (event) => {
      if (!isProtectedAsset(event.target)) return;
      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const key = event.key.toLowerCase();
      const blocksDevToolsShortcut =
        event.key === 'F12' ||
        ((event.ctrlKey || event.metaKey) && event.shiftKey && ['i', 'j', 'c', 'k'].includes(key)) ||
        (event.metaKey && event.altKey && ['i', 'j', 'c', 'u'].includes(key)) ||
        ((event.ctrlKey || event.metaKey) && ['u', 's'].includes(key));

      if (!blocksDevToolsShortcut) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );



  const setDevToolsState = () => {
    const widthGap = Math.abs(window.outerWidth - window.innerWidth);
    const heightGap = Math.abs(window.outerHeight - window.innerHeight);
    const devToolsLikelyOpen = widthGap > 160 || heightGap > 260;
    document.documentElement.classList.toggle('image-copy-deterrent-devtools', devToolsLikelyOpen);
  };

  setDevToolsState();
  window.addEventListener('resize', setDevToolsState, { passive: true });
  window.setInterval(setDevToolsState, 1000);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(protectedMediaSelector)) {
          node.setAttribute('draggable', 'false');
          node.setAttribute('oncontextmenu', 'return false;');
        }
        disableMediaDragging(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
